import { Icon, IconNames } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import { ToggleIconSC } from '../MobileMenu.styled'

export interface IToggleIcon {
  icon?: IconNames
  color?: string
}

export const ToggleIcon = ({
  icon = IconNames.lines,
  color = COLOR.TEXT_ICON_CONSTANT_LIGHT,
}: IToggleIcon) => {
  return (
    <ToggleIconSC>
      <Icon name={icon} color={color} />
    </ToggleIconSC>
  )
}
